import * as PIXI from 'pixi.js';

export default class Sprite {

    constructor(pixiContainer) {
        const white = PIXI.Texture.WHITE;
        // const texture = PIXI.Texture.from('./assets/Textures/skybox_nx.jpg');
        const sprite = PIXI.Sprite.from(white);
        const canvas = document.getElementById("renderCanvas");
        sprite.position.set(canvas.width / 2, canvas.height / 2);
        // pixiContainer.addChild(sprite);

    }
}